module.exports = __webpack_public_path__ + "static/media/light-switch.f5928069.svg";